import { makeModule } from '@codium/codium-vue'
import { storeModule as settings } from './user/settings'

export const storeModule = makeModule('user', {
  modules: {
    settings,
  }
})
